import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=36eb90fc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=36eb90fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eb90fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36eb90fc')) {
      api.createRecord('36eb90fc', component.options)
    } else {
      api.reload('36eb90fc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=36eb90fc&scoped=true&", function () {
      api.rerender('36eb90fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29NZOw29qBVuz/JS/comp/PopupBox.vue"
export default component.exports